export const env = () => (process.env.REACT_APP_ENV)

export const domain = (key) => {
    const list = {
        tool: {
            url: process.env.REACT_APP_URL,
            ws: process.env.REACT_APP_WS_URL
        },
        pm: {
            url: process.env.REACT_APP_URL_PM,
            ws: process.env.REACT_APP_WS_URL_PM
        },
        mp: {
            url: process.env.REACT_APP_URL_MP,
            ws: process.env.REACT_APP_WS_URL_MP
        },
        psl: {
            url: process.env.REACT_APP_URL_PSL,
            ws: process.env.REACT_APP_WS_URL_PSL
        },
        biz: {
            url: process.env.REACT_APP_URL_BIZ,
            ws: process.env.REACT_APP_WS_URL_BIZ
        },
        api: {
            tool: process.env.REACT_APP_API_URL_TOOL,
            global: process.env.REACT_APP_API_URL_GLOBAL,
        }
    }

    return list[key]
}

export const key = (key) => {
    const list = {
        gapi_key: process.env.REACT_APP_POF_GLOBAL_API_KEY,
        tapi_key: process.env.REACT_APP_TOOL_API_KEY,
        aui_key: process.env.REACT_APP_AUI_KEY,
        tsa_key: process.env.REACT_APP_TSA_KEY,
        tid: process.env.REACT_APP_TID
    }

    return list[key]
}

export const aws = (key) => {
    const list = {
        secret_key: process.env.REACT_APP_AWSS3_SECRET_ACCESS_KEY,
        access_key: process.env.REACT_APP_AWSS3_ACCESS_KEY_ID,
        bucket_name: process.env.REACT_APP_AWSS3_BUCKET_NAME,
        region: process.env.REACT_APP_AWSS3_REGION,
    }

    return list[key]
} 